import { Select } from "antd";
import { useEffect, useState } from "react";
import { GetRequest } from "../../utils/api";

interface Props {
    bluprintApi: string,
    dropDownCode: string,
    dorpDownLabel: string,
    onChange: Function,
    dataApiMap: any[]
}

const DataTableFilter: React.FC<Props> = ({
    bluprintApi,
    dropDownCode,
    dorpDownLabel,
    onChange,
    dataApiMap = []
}) => {
    const [options, setOptions] = useState<any>();

    useEffect(() => {
        GetRequest(bluprintApi).then((res: any) => {
            setOptions(res.records);
        });
    }, [bluprintApi]);

    // Convert options to the format expected by antd 5
    const selectOptions = options?.map((option: any) => ({
        value: option[dropDownCode],
        label: option[dorpDownLabel],
    }));

    const handleOnChange = (val: string) => {
        if (dataApiMap && dataApiMap.length > 0) {
            const currentItem = dataApiMap.find((item) => item.code === val);
            if (currentItem) {
                const dataApi = currentItem.dataApi;
                onChange(dataApi);
            }
        }
    }

    return (
        <Select allowClear={true}
            className="mx-2"
            style={{ width: "160px" }}
            placeholder={"Select Table"}
            options={selectOptions}
            onChange={(val) => handleOnChange(val)}
            onClear={() => onChange("")}
        />
    );
};

export default DataTableFilter;